import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	NgbNavModule,
	NgbAccordionModule,
	NgbDropdownModule,
	NgbAlertModule,
	NgbModule,
} from '@ng-bootstrap/ng-bootstrap';

// Swiper Slider
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

// Counter
import { CountToModule } from 'angular-count-to';

import { LoaderComponent } from './loader/loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { OnDisplayComponent } from './on-display/on-display.component';
import { BugReportButtonComponent } from './bug-report-button/bug-report-button.component';
import { NewColumnSelectorComponent } from './new-column-selector/new-column-selector.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
	direction: 'horizontal',
	slidesPerView: 'auto',
};

@NgModule({
	declarations: [
		LoaderComponent,
		OnDisplayComponent,
		BugReportButtonComponent,
		NewColumnSelectorComponent,
	],
	imports: [
		FormsModule,
		CommonModule,
		NgbNavModule,
		NgbAccordionModule,
		NgbDropdownModule,
		SwiperModule,
		CountToModule,
		NgbAlertModule,
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		RouterModule,
		NgxDaterangepickerMd.forRoot(),
	],
	exports: [
		LoaderComponent,
		OnDisplayComponent,
		BugReportButtonComponent,
		NewColumnSelectorComponent,
	],
})
export class SharedModule {}
